/**
 * First-party cookie helpers shared by the analytics modules: cookies are
 * scoped to `.storyworth.com` on Storyworth hosts (so Webflow and the app see
 * the same values), `SameSite=Lax`, and `Secure` on https.
 */

export function setStoryworthCookie(
  name: string,
  value: string,
  maxAgeSeconds: number,
) {
  document.cookie = cookieString(name, value, [
    `max-age=${maxAgeSeconds}`,
    "path=/",
    "SameSite=Lax",
    storyworthCookieDomainAttribute(),
    secureCookieAttribute(),
  ])
}

export function clearStoryworthCookie(name: string) {
  setStoryworthCookie(name, "", 0)
}

/** Raw value of the named cookie ("" when absent); callers decode as needed. */
export function cookieValue(name: string): string {
  const cookies = document.cookie ? document.cookie.split("; ") : []
  for (const cookie of cookies) {
    const parts = cookie.split("=")
    if (parts[0] === name) return parts.slice(1).join("=")
  }
  return ""
}

export function cookieString(
  name: string,
  value: string,
  attributes: string[],
) {
  return [`${name}=${value}`, ...attributes.filter(Boolean)].join("; ")
}

export function storyworthCookieDomainAttribute() {
  const hostname = window.location.hostname.toLowerCase()
  if (hostname === "storyworth.com" || hostname.endsWith(".storyworth.com")) {
    return "domain=.storyworth.com"
  }
  return ""
}

export function secureCookieAttribute() {
  return window.location.protocol === "https:" ? "Secure" : ""
}
